// To check if the top ATC button or another specific button is visible or not
let observer = new IntersectionObserver(function(entries) {
    let bottomATC = document.querySelector('.bottom-atc');

    if (entries[0].isIntersecting === true) {
        bottomATC.classList.add('hide');
        bottomATC.classList.remove('show');
    } else {
        bottomATC.classList.remove('hide');
        bottomATC.classList.add('show');
    }
});

// Check and observe elements if they exist
setTimeout(() => {
    let bundlesButton = document.querySelector('.bogos-bundles-quantity-break-button-add');

    if (bundlesButton) {
        console.log('Observer quantity break offer');
        
        observer.observe(bundlesButton);
    }
}, 1400);

let addToCartBtn = document.querySelector('.product-action .addToCartBtn');




if (addToCartBtn) {
    observer.observe(addToCartBtn);
}
// End



// to jump to the top ATC button while clicking on the bottom ATC button
document.querySelectorAll('.batc_content a[href^="#"]').forEach(element => {
    element.addEventListener('click', event => {
        var target = document.querySelector(element.getAttribute('href'));
        if (target) {
            event.preventDefault();
            var targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
            var windowHeight = window.innerHeight;
            var targetHeight = target.offsetHeight;
            var position = targetPosition - (windowHeight - targetHeight) / 2;
            window.scroll({
                top: position,
                behavior: 'smooth'
            });
        }
    });
});